<div class="remember-device text-center">
  <label class="remember-label">
    <input name="remember-device-checkbox" id="remember-device-checkbox"
      type="checkbox"
      [(ngModel)]="authenticationService.rememberDevice"
      name="rememberDevice"
    />
    <span>Remember this device for 30 Days</span>
  </label>
</div>  